import { useState, useEffect, useContext } from "react";
import { NavLink, useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { SelectedCardContext } from "../../../Context/SelectedCardContext";
import styles from "./Header.module.css";
import hyproclogo from "../../../Assests/Images/hyproclog0.png";
import hamnburgerIcon from "../../../Assests/icons/ic-hamburg.svg";
import hamnburgeCrossIcon from "../../../Assests/icons/ic-cross-white.svg";
import searchIcon from "../../../Assests/icons/searchIcon.svg";
import HeaderContentSection from "./HeaderContentSection";

import globalTechbg from "../../../Assests/Images/homebgimage.png";
import headerLogo from '../../../Assests/icons/headerLogo.svg'
import imagebg from '../../../Assests/Images/homePagebg.png'
import { Search } from "lucide-react";
import homeAbout2 from "../../../Assests/Images/homeAbout2.jpg";
import homeAbout3 from "../../../Assests/Images/homeAbout3.png";

import productsupply from "../../../Assests/Images/product-supply.png";
import homeAbout1 from "../../../Assests/Images/homeAbout1.png";
import contactusBg from "../../../Assests/Images/contactusBg.jpeg";

const Header = () => {
  const location = useLocation();
  const { selectedCard, setSelectedCard } = useContext(SelectedCardContext);
  const [showMobileMenu, setShowMobileMenu] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const isHomePage = location.pathname === "/";

  const toggleMobileMenu = () => {
    setShowMobileMenu(!showMobileMenu);
  };


  const navigate = useNavigate();
  const toggleDropdown = () => {
    navigate("/");
  };



useEffect(() => {
  if (location.pathname === "/global") {
    setBgImage(homeAbout2);
  }  else if (location.pathname === "/product" && location.pathname === "/procurement") {
    setBgImage(productsupply);
  }
  else if (location.pathname === "/about") {
    setBgImage(homeAbout1);
  }
  else if (location.pathname === "/contact") {
    setBgImage(contactusBg);
  }
}, [location.pathname]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (showMobileMenu && !event.target.closest(`.${styles.mobileMenu}`) && !event.target.closest(`.${styles.hamburger}`)) {
        setShowMobileMenu(false);
      }
    };
    document.addEventListener("click", handleClickOutside);
    return () => document.removeEventListener("click", handleClickOutside);
  }, [showMobileMenu]);

  useEffect(() => {
    const handleResize = () => {
      const isNowMobile = window.innerWidth <= 768;
      if (!isNowMobile) {
        setShowMobileMenu(false);
      } else {
        setShowMobileMenu(false);
      }
      setIsMobile(isNowMobile);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  
  const [bgImage, setBgImage] = useState(imagebg);

  const handleImageClick = (newImage) => {
    if (location.pathname !== "/global") {
      setBgImage(newImage);
      console.log("Image clicked:", newImage);
    }
  };

  const handleNavLinkClick = (route, bgImage) => {
    setSelectedCard(null); // Clear selected card
    setBgImage(bgImage);
    if (isMobile) {
      toggleMobileMenu();
    }
  };

  return (
    
    <div className={styles.mainHeader} style={{ backgroundImage: `url(${selectedCard ? selectedCard.image : bgImage})` }}>
      <div className={styles.mainHeaderOverlay}>
    <header className={`${isHomePage ? styles.otherHeader : styles.header_section}`}>
          <div className={`${!isMobile ? styles.topBar : ''}`}>
            {/* Left Section - Navigation & Search Icon */}
            <div className={styles.leftSection}>
              {!isMobile && (
                <div aria-label="Search">
                  <Search className={styles.searchIcon} />
                </div>
              )}
              {!isMobile && (
                <nav className={styles.navBar}>
                  <ul className={styles.navList}>
                    <li>
                      <NavLink to="/" className={location.pathname === "/" ? styles.navLinkActive : styles.navLink}
                      onClick={() => { setSelectedCard(null); handleNavLinkClick("/", imagebg); }}>
                        HOME
                      </NavLink>
                    </li>
                    <li>
                      <NavLink to="/about" className={location.pathname === "/about" ? styles.navLinkActive : styles.navLink}
                      onClick={() => { setSelectedCard(null); handleNavLinkClick("/about", homeAbout1); }}>
                        ABOUT US
                      </NavLink>
                    </li>
                    <li>
                    <NavLink to="/global" 
                      className={location.pathname === "/global" ? styles.navLinkActive : styles.navLink}
                     onClick={() => { setSelectedCard(null); handleNavLinkClick("/global", homeAbout2); }}>
                      GLOBAL TEAM
                    </NavLink>
                    </li>
                    <li>
                      <NavLink to="/product" className={location.pathname === "/product" ? styles.navLinkActive : styles.navLink}
                      onClick={() => { setSelectedCard(null); toggleMobileMenu(); handleNavLinkClick("/product", productsupply); }}>
                        PRODUCT & SUPPLY
                      </NavLink>
                    </li>
                    <li>
                      <NavLink to="/procurement" className={location.pathname === "/procurement" ? styles.navLinkActive : styles.navLink}
                      onClick={() => { setSelectedCard(null); toggleMobileMenu();  handleNavLinkClick("/procurement", homeAbout3)}}>
                        PROCUREMENT & SHIPPING
                      </NavLink>
                    </li>
                    <li>
                      <NavLink to="/contact" className={location.pathname === "/contact" ? styles.navLinkActive : styles.navLink}
                      onClick={() => { setSelectedCard(null); toggleMobileMenu(); }}>
                        CONTACT US
                      </NavLink>
                    </li>
                  </ul>
                </nav>
              )}
            </div>

            {/* Right Section - Logo */}
            {!isMobile && (
            <div className={styles.rightSection}>
              <h1 className={styles.logo}>
                <img src={headerLogo} alt="Hyproc Logo"  onClick={toggleDropdown}/>
              </h1>
            </div>
            )}
          </div>

          {/* Mobile Navigation */}
          {isMobile && (
            <div className={styles.mobileHeader}>
              <button className={styles.hamburger} onClick={toggleMobileMenu}>
                <img src={hamnburgerIcon} alt="Menu" />
              </button>
              <div className={styles.logo}>
                <img src={headerLogo} alt="Hyproc Logo" />
              </div>
             
            </div>
          )}

          {showMobileMenu && isMobile && <div className={`${styles.overlay} ${showMobileMenu ? styles.show : ""}`}></div>}

          {isMobile && (
            <nav className={`${styles.mobileMenu} ${showMobileMenu ? styles.openMenu : ""}`}>
              <button className={styles.closeButton} onClick={toggleMobileMenu}>
                <img src={hamnburgeCrossIcon} alt="Close" />
              </button>
              <ul className={styles.navList}>
                <li>
                <div aria-label="Search">
                <Search className={styles.mobileSearchIcon} />
              </div>
                </li>
                <li>
                  <NavLink to="/" className={location.pathname === "/" ? styles.navLinkActive : styles.navLink} onClick={toggleMobileMenu}>
                    HOME
                  </NavLink>
                </li>
                <li>
                  <NavLink to="/about" className={location.pathname === "/about" ? styles.navLinkActive : styles.navLink} 
                   onClick={() => { setSelectedCard(null); handleNavLinkClick("/global", homeAbout2); }}>
                    ABOUT US
                  </NavLink>
                </li>
                <li>
                <NavLink to="/global" 
                  className={location.pathname === "/global" ? styles.navLinkActive : styles.navLink}
                  onClick={() => { setSelectedCard(null); handleNavLinkClick("/global", homeAbout2); }}>
                  GLOBAL TEAM
                </NavLink>
                </li>
                <li>
                  <NavLink to="/product" className={location.pathname === "/product" ? styles.navLinkActive : styles.navLink} onClick={() => { setSelectedCard(null); toggleMobileMenu(); }}>
                    PRODUCT & SUPPLY
                  </NavLink>
                </li>
                <li>
                  <NavLink to="/procurement" className={location.pathname === "/procurement" ? styles.navLinkActive : styles.navLink} onClick={() => { setSelectedCard(null); toggleMobileMenu(); handleNavLinkClick("/procurement", homeAbout3);}}>
                    PROCUREMENT & SHIPPING
                  </NavLink>
                </li>
                <li>
                  <NavLink to="/contact" className={location.pathname === "/contact" ? styles.navLinkActive : styles.navLink} onClick={() => { setSelectedCard(null); toggleMobileMenu(); }}>
                    CONTACT US
                  </NavLink>
                </li>
              </ul>
            </nav>
          )}
        </header>
        {selectedCard ? (
        <div className={styles.globalHeader}>
          <div className={styles.globalTitleOverlay}>
            <div className={styles.globalTitle}>{selectedCard.title}</div>
            <div className={styles.globalSubtitle}>
              {selectedCard.description}
            </div>
          </div>
        </div>
      ) : (
        <>
{location.pathname === "/about" && (
            <div className={styles.globalHeader}>
              <div className={styles.globalTitleOverlay}>
                <div className={styles.globalTitle}>About Hyproc</div>
                <div className={styles.globalSubtitle}>
                  Global Procurement & Logistics, Redefined for Your Industry
                </div>
              </div>
            </div>
          )}

          {location.pathname === "/global" && (
            <div className={styles.globalHeader}>
              <div className={styles.globalTitleOverlay}>
                <div className={styles.globalTitle}>Our Global Team</div>
              </div>
            </div>
          )}
          {location.pathname === "/contact" && (
            <div className={styles.globalHeader}>
              <div className={styles.globalTitleOverlay}>
                <div className={styles.globalTitle}>Contact Us</div>
              </div>
            </div>
          )}

          {location.pathname === "/product" && (
            <div className={styles.globalHeader}>
              <div className={styles.globalTitleOverlay}>
                <div className={styles.globalTitle}>Product and Supply</div>
                <div className={styles.globalSubtitle}>
                  We provide durable machinery and vehicles to enhance productivity, from site-ready equipment to specialized transport solutions.
                </div>
              </div>
            </div>
          )}
          {location.pathname === "/procurement" && (
            <div className={styles.globalHeader}>
              <div className={styles.globalTitleOverlay}>
                <div className={styles.globalTitle}>Procurement & Shipping</div>
                <div className={styles.globalSubtitle}>
                  Emphasizes smooth supply chain movement.
                </div>
              </div>
            </div>
          )}
        </>
      )}

        {location.pathname === "/" && <HeaderContentSection onImageClick={handleImageClick}></HeaderContentSection>}
      </div>
    </div>
  );
};

export default Header;
